import * as React from 'react';
import { Wrapper, Container } from './index.style';
import { Heading } from '@lendi-ui/typography';
import { Social } from './components/Social';
import { GeneralInfo } from './components/GeneralInfo';
import { MainPages } from './components/MainPages';
import { LUIGlobalProps } from '@lendi-ui/utils';
import { withTheme } from 'styled-components';
import { ThemeMap } from '@lendi/ui/Theme';
import { FooterAnalyticsProvider, trackFooterNavigation } from './components/utils/analytics';

export interface FooterProps extends LUIGlobalProps {
  broker?: Broker;
  theme?: ThemeMap;
  params?: string;
}

interface Broker {
  fullName: string;
  photo: string;
  phone: string;
  title: string;
}

const Footer = (props: FooterProps) => {
  const { params, ...otherProps } = props;
  return (
    <Wrapper {...otherProps}>
      <Container>
        <Heading size="md" color="shade.0" mb={{ mobile: 'sm', tablet: 'sm', desktop: 'md' }}>
          Still looking?
        </Heading>
        <FooterAnalyticsProvider
          value={{
            analyticsForFooter: (text: string, type?: string) => trackFooterNavigation({ text, type }),
          }}
        >
          <MainPages params={params} />
          <GeneralInfo params={params} />
          <Social />
        </FooterAnalyticsProvider>
      </Container>
    </Wrapper>
  );
};

export default withTheme(Footer);
